// "CD_SURVEY_STATION": [
//   {
//     "well_id": "4v7CxWtBMn",
//     "wellbore_id": "3fDnfh8UFt",
//     "survey_header_id": "3C1Ql",
//     "survey_id": "atbXD",
//     "azimuth": "237.08478953138692",// azi
//     "survey_date": "{ts '2019-10-20 08:39:02'}",
//     "offset_east": "-0.7570262656993251", // ew
//     "offset_north": "-0.14996070370648637", // ns
//     "inclination": "0.75", // inc
//     "build_rate": "-0.08142476", // build
//     "md": "911.35170560485",  // md
//     "tvd": "911.3464918354009", // tvd
//     "sequence_no": "4",
//     "dogleg_severity": "0.08840049", // dls
//     "tool_face_angle": "-157.55617", \\
//     "station_type": "0",
//     "turn_rate": "-2.5784507", // turn
//     "grav_axial_raw": "0.0",
//     "grav_tran1_raw": "0.0",
//     "grav_tran2_raw": "0.0",
//     "mag_axial_raw": "0.0",
//     "mag_tran1_raw": "0.0",
//     "mag_tran2_raw": "0.0"
//   },

// used for survey  runs  and survey plan
// survey points missing Build Turn TFO

import { KnowEdmTableData } from './table-enums.js';

const surveyPointsMap = new Map();

surveyPointsMap.set(KnowEdmTableData.Md, {
  key: KnowEdmTableData.Md,
  label: 'MD',
  unit: '',
});

surveyPointsMap.set(KnowEdmTableData.Inclination, {
  key: KnowEdmTableData.Inclination,
  label: 'INC',
  unit: '',
});

surveyPointsMap.set(KnowEdmTableData.Azimuth, {
  key: KnowEdmTableData.Azimuth,
  label: 'AZI',
  unit: '',
});

surveyPointsMap.set(KnowEdmTableData.Tvd, {
  key: KnowEdmTableData.Tvd,
  label: 'TVD',
  unit: '',
});

surveyPointsMap.set(KnowEdmTableData.OffsetEast, {
  key: KnowEdmTableData.OffsetEast,
  label: 'EW',
  unit: '',
});

surveyPointsMap.set(KnowEdmTableData.OffsetNorth, {
  key: KnowEdmTableData.OffsetNorth,
  label: 'NS',
  unit: '',
});

surveyPointsMap.set(KnowEdmTableData.Vsec, {
  label: 'V.sec', // virtual property needs to be calculated
  unit: '',
  handler: (row: any) => {
    const { offset_north: ns, offset_east: ew } = row;
    const beta = Math.atan2(ns, ew);
    const vs = Math.sqrt(ns ** 2 + ew ** 2) * Math.sin(beta);
    return vs;
  },
});

surveyPointsMap.set(KnowEdmTableData.BuildRate, {
  key: KnowEdmTableData.BuildRate,
  label: 'Build',
  unit: '',
});

surveyPointsMap.set(KnowEdmTableData.DoglegSeverity, {
  key: KnowEdmTableData.DoglegSeverity,
  label: 'DLS',
  unit: '',
});

surveyPointsMap.set(KnowEdmTableData.TurnRate, {
  key: KnowEdmTableData.TurnRate,
  label: 'Turn',
  unit: '',
});

surveyPointsMap.set(KnowEdmTableData.ToolFaceAngle, {
  key: KnowEdmTableData.ToolFaceAngle,
  unit: '',
  label: 'TFO',
});

export {
  surveyPointsMap,
};